import React, { useState } from 'react'
import FinePrint from 'components/Common/FinePrint'
import Modal from 'components/Luxkit/Modal/Modal'

interface Props {
  offer: App.Offer;
  defaultShowModal?: boolean;
}

export default function FinePrintModal({ offer }: Props) {
  // will remove this after we decide if we want it in a modal or a message
  const [showModal, setShowModal] = useState(true)

  return (
    <Modal
      size="L"
      isOpen={showModal}
      title="Fine print"
      onClose={() => setShowModal(false)}
    >
      <FinePrint finePrint={offer.finePrint} offer={offer} />
    </Modal>
  )
}
